import { render, staticRenderFns } from "./SectionIndexItenNews.vue?vue&type=template&id=15c3f1a2&scoped=true"
import script from "./SectionIndexItenNews.vue?vue&type=script&lang=js"
export * from "./SectionIndexItenNews.vue?vue&type=script&lang=js"
import style0 from "./SectionIndexItenNews.vue?vue&type=style&index=0&id=15c3f1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3f1a2",
  null
  
)

export default component.exports